/**
 * Brand served for the current request host.
 *
 * Values must match PlatformBrand on the backend, injected as window.BRAND.
 */
const BRANDS = {
  missionDev: "MISSION_DEV",
  talentSimple: "TALENT_SIMPLE",
};

const BRAND_LOGO_VARIANTS = {
  wordmark: "wordmark",
  icon: "icon",
  marketing: "marketing",
};

const BRAND_CONFIG = {
  [BRANDS.missionDev]: {
    name: "Mission",
    legalName: "Mission Inc.",
    websiteUrl: "https://mission.dev",
    logoAltId: "Brand.MissionDev.LogoAlt",
  },
  [BRANDS.talentSimple]: {
    name: "TalentSimple",
    legalName: "TalentSimple",
    websiteUrl: "https://talentsimple.ai",
    logoAltId: "Brand.TalentSimple.LogoAlt",
  },
};

const getCurrentBrand = () => {
  const brand = typeof window === "undefined" ? undefined : window.BRAND;

  return Object.values(BRANDS).includes(brand) ? brand : BRANDS.missionDev;
};

const isTalentSimpleBrand = (brand = getCurrentBrand()) => brand === BRANDS.talentSimple;

const getBrandConfig = (brand = getCurrentBrand()) => BRAND_CONFIG[brand];

const getBrandRichTextElements = (brand = getCurrentBrand()) => ({
  brand: () => BRAND_CONFIG[brand].name,
  brandLegal: () => BRAND_CONFIG[brand].legalName,
});

export {
  BRAND_LOGO_VARIANTS,
  BRAND_CONFIG,
  getCurrentBrand,
  isTalentSimpleBrand,
  getBrandConfig,
  getBrandRichTextElements,
};

export default BRANDS;
